import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import {Sort} from "@angular/material/sort";
import {
  GeneralItemDetailDialogComponent
} from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import {BoxEvent} from "../../../model/box-event";
import {BoxEventsService} from "../../../services/box-events.service";
import {Constants} from "../../../utils/constants";
import {Box} from "../../../model/box";
import {Contract} from "../../../model/contract";
import {User} from "../../../model/user";
import {Sim} from "../../../model/sim";
import {BoxCertificate} from "../../../model/box-certificate";
import {SplitCamelCasePipe} from "../../../pipes/split-camel-case.pipe";


@Component({
  selector: 'aw-list-box-events',
  templateUrl: './list-box-events.component.html',
  styleUrls: ['./list-box-events.component.scss']
})
export class ListBoxEventsComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'timestamp',
    'user',
    // 'contractId',
    'eventsType',
    'details',
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorBoxEvents') paginatorUsers!: MatPaginator;
  @Input() embeddedLayout = false;
  @Input() box?: Box;
  @Input() contract?: Contract;
  dataSource!: MatTableDataSource<BoxEvent>;
  entities = Constants.entities;
  private allBoxEvents$!: Observable<BoxEvent[]>;

  constructor(
    public dialog: MatDialog,
    private boxEventsService: BoxEventsService,
    private splitCamelCase: SplitCamelCasePipe
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.allBoxEvents$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (this.box && this.contract)
              return this.boxEventsService.getAllBoxEventsByContract(this.contract.id, this.box.id);
            return this.boxEventsService.getAllBoxEvents(this.box?.id);
          }),
          tap(boxEvents => {

            boxEvents.forEach(event => {


              event.appliant = event.createdBy?.identityProviderId === '0' ? 'AUTO' : `${(event.createdBy as User)?.firstName} ${(event.createdBy as User)?.lastName}`;

              switch (event.eventsType) {

                case Constants.boxEventTypes.statusChange:
                  event.details = `Previous status: ${this.splitCamelCase.transform(event.jsonData?.previousStatus)} Applied Status: ${this.splitCamelCase.transform(event.jsonData?.appliedStatus)}`;
                  break;

                case Constants.boxEventTypes.boxEnabled:
                case Constants.boxEventTypes.boxDisabled:
                  break;

                case Constants.boxEventTypes.researcherAssigned:
                  event.details = `Researcher: ${(event.jsonData?.researcher as User)?.firstName}  ${(event.jsonData?.researcher as User)?.lastName}`;
                  break;

                case Constants.boxEventTypes.researcherRemoved:
                  event.details = `Researcher: ${(event.jsonData?.researcher as User)?.firstName} ${(event.jsonData?.researcher as User)?.lastName}`;
                  break;

                case Constants.boxEventTypes.simAssigned:
                  event.details = `Sim: ${(event.jsonData?.sim as Sim)?.identifier}`;
                  break;

                case Constants.boxEventTypes.simRemoved:
                  event.details = `Sim: ${(event.jsonData?.sim as Sim)?.identifier}`;
                  break;

                case Constants.boxEventTypes.certificateAssigned:
                  event.details = `Certificate: ${(event.jsonData?.certificate as BoxCertificate)?.cmId}`;
                  break;

                case Constants.boxEventTypes.certificateRemoved:
                  event.details = `Certificate: ${(event.jsonData?.certificate as BoxCertificate)?.cmId}`;
                  break;
              }
            });

            this.dataSource = new MatTableDataSource<BoxEvent>(boxEvents);
            this.dataSource.paginator = this.paginatorUsers;
            this.loading = false;
          })
        );
    this.allBoxEvents$.subscribe();
  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortBoxEvents(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }


    }
    );
  }

  details(boxEvent: BoxEvent): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: boxEvent });
  }

}
